export const ManyDependenciesNoneInstalledNotificationDataHooks = {
  container: 'many-dependencies-none-installed-notification-container',
  description: 'many-dependencies-none-installed-notification-description',
  dependencyLink: (slug: string) =>
    `many-dependencies-none-installed-notification-app-dependency-${slug}`,
};
